// eslint-disable-next-line
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import CustomCountTable from '../../../component/molecules/CustomCountTable';
import { actions } from '../../../redux/modules/Actions';
import { filterKeyState } from '../../../redux/reducers/CurrentFilterReducer';
import { SearchConditionState } from '../../../redux/reducers/SearchConditionReducer';


const mapStateToProps = () => {
  return {
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    updateFilterCondition: (state: filterKeyState) => {
      dispatch(actions.updateCurrentFilter(state));
    },
    updateSearchCondition: (payload: SearchConditionState, isNotFilter: boolean) => {
      if (isNotFilter) {
        dispatch(actions.clearFilter());
      }
      dispatch(actions.updateSearchCondition(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomCountTable);
